// // src/pages/Pipeline/Measurement.jsx
// import React, { useState } from "react";
// import { Box, Paper, TextField, Typography, Button } from "@mui/material";
// import { useNavigate, useParams } from "react-router-dom";
// import api from "../../utils/api";

// export default function Measurement() {
//   const { id } = useParams();
//   const navigate = useNavigate();

//   const [form, setForm] = useState({
//     total_area: "",
//     room_details: "",
//     remarks: ""
//   });

//   async function submit(e) {
//     e.preventDefault();
//     try {
//       await api.post("/leads/measurement", {
//         lead_id: id,
//         total_area: form.total_area,
//         room_details: JSON.parse(form.room_details || "{}"),
//         remarks: form.remarks
//       });
//       alert("Measurement saved!");
//       navigate(`/leads/${id}`);
//     } catch (err) {
//       console.error(err);
//       alert("Failed to save measurement");
//     }
//   }

//   return (
//     <Box sx={{ p: 3 }}>
//       <Typography variant="h5">Measurement Entry</Typography>
//       <Paper sx={{ p: 3, mt: 2 }}>
//         <form onSubmit={submit}>
//           <TextField
//             label="Total Area (sqft)"
//             fullWidth required sx={{ mb: 2 }}
//             value={form.total_area}
//             onChange={(e) => setForm({ ...form, total_area: e.target.value })}
//           />

//           <TextField
//             label="Room Details (JSON)"
//             placeholder='{"hall":"200 sqft", "bedroom1":"150 sqft"}'
//             fullWidth multiline rows={4} sx={{ mb: 2 }}
//             value={form.room_details}
//             onChange={(e) => setForm({ ...form, room_details: e.target.value })}
//           />

//           <TextField
//             label="Remarks"
//             fullWidth multiline rows={3} sx={{ mb: 2 }}
//             value={form.remarks}
//             onChange={(e) => setForm({ ...form, remarks: e.target.value })}
//           />

//           <Button type="submit" variant="contained">Save</Button>
//           <Button sx={{ ml: 2 }} variant="outlined" onClick={() => navigate(-1)}>Back</Button>
//         </form>
//       </Paper>
//     </Box>
//   );
// }

import React, { useState } from "react";
import api from "../../utils/api";
import { useParams, useNavigate } from "react-router-dom";
import { Box, Paper, TextField, Button, Typography } from "@mui/material";

export default function Measurement() {
  const { id } = useParams();
  const navigate = useNavigate();

  const [totalArea, setTotalArea] = useState("");
  const [roomText, setRoomText] = useState("");  // <-- raw text input
  const [remarks, setRemarks] = useState("");

  function convertToJSON(text) {
    // Example input:
    // hall 200
    // bedroom 150

    const lines = text.split("\n").filter(x => x.trim() !== "");

    return lines.map(line => {
      const parts = line.trim().split(" ");
      const name = parts[0];
      const area = Number(parts[1]) || 0;
      return { room: name, area };
    });
  }

  async function submit(e) {
    e.preventDefault();

    try {
      const room_details = convertToJSON(roomText);  // <- convert here

      await api.post("/leads/measurement", {
        lead_id: id,
        total_area: totalArea,
        room_details,
        remarks
      });

      alert("Measurement Saved!");
      navigate(`/leads/${id}`);
    } catch (err) {
      console.error(err);
      alert("Error saving measurement");
    }
  }

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h5">Add Measurement</Typography>

      <Paper sx={{ p: 2, mt: 2 }}>
        <form onSubmit={submit}>

          <TextField
            label="Total Area (sqft)"
            fullWidth
            sx={{ mb: 2 }}
            value={totalArea}
            onChange={e => setTotalArea(e.target.value)}
          />

          <TextField
            label="Room Details (one per line: room area)"
            fullWidth
            multiline
            rows={5}
            sx={{ mb: 2 }}
            value={roomText}
            onChange={e => setRoomText(e.target.value)}
            placeholder={`hall 200\nbedroom 150\nkitchen 80`}
          />

          <TextField
            label="Remarks"
            fullWidth
            sx={{ mb: 2 }}
            value={remarks}
            onChange={e => setRemarks(e.target.value)}
          />

          <Button variant="contained" type="submit">Save Measurement</Button>
        </form>
      </Paper>
    </Box>
  );
}
